module.exports = __webpack_public_path__ + "static/media/ci.3ff2bcbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ci.svg
// module id = 85
// module chunks = 0